import { Divider } from '@wheely/ui-kit';
import { FormattedMessage } from 'react-intl';

import { Pressure } from '@/modules/common/model/pressure';

import s from './CityPressure.module.css';

const CityPressure = ({ value, cityName }: { value: Pressure | null; cityName?: string }) => (
  <div className={s.cityPressureWrapper}>
    <Divider dark={true} noMargin={true} className={s.divider} />
    <div className={s.cityPressure}>
      <div className={s.cityPressureLabel}>
        <FormattedMessage
          defaultMessage="Estimated City Load"
          id="eAryok"
          description="nav menu item"
          tagName="span"
        />
        <span className={s.cityLabel}>{cityName}</span>
      </div>
      <div className={s.pressureValue} data-value={value}>
        {value ?? '—'}
      </div>
    </div>
  </div>
);

export { CityPressure };
